
<div *ngIf="diary" class="flex flex-column overflow-y-scroll">
    <div class=" pt-3 flex-auto">
        <p-floatLabel>
            <input id="subject" type="text" pInputText [(ngModel)]="diary.subject" style="width:100%">
            <label for="subject">Subject</label>
        </p-floatLabel>
    </div>
    <div class="flex pt-3 grid">
        <div class="field col-6">
            <p-floatLabel>
                <p-calendar id="dueDate" [(ngModel)]="diary.dueDate" [style]="{'width':'100%'}"></p-calendar>
                <label for="dueDate">Due Date</label>
            </p-floatLabel>
        </div>
        <div class="col-6 field">
            <p-dropdown [(ngModel)]="diary.assignedTo" [options]="(activeUsers$ | async) ?? []" optionLabel="fullName" dataKey="id" placeholder="Assign To User" [style]="{'width':'100%'}"></p-dropdown>
        </div>
    </div>
    <div class="field">
        <p-editor [(ngModel)]="diary.body" [style]="{ height: '250px' }" />     
    </div>
    <div class="flex mt-2 justify-content-center" >
        <p-buttonGroup>
            <p-button label="Save" icon="pi pi-check" (onClick)="saveButtonPressed($event)" [disabled]="!allowSave()"></p-button>
            <p-button label="Cancel" icon="pi pi-times" severity="danger" (onClick)="cancelButtonPressed($event)"></p-button>
        </p-buttonGroup>
    </div>
</div>
